import React from "react"
import {ContentLayout} from "../../layouts/ContentLayout";
import {useParams} from "react-router";
import EatTaskFormContainer from "../../components/containers/EatTaskFormContainer";

export function EatTaskForm(props) {

    let {id} = useParams();

    return (
        <ContentLayout title={id ? "Редактирование задачи для Берёзки" : "Добавление задачи для Березки"}>
            <div className="row">
                <div className="col-6 p-0">
                    <br />
                    <EatTaskFormContainer id={id} />
                </div>
            </div>
        </ContentLayout>
    );
}
